import { render, staticRenderFns } from "./CarrinhoEmpresaAgrupamentoItem.vue?vue&type=template&id=ca54f908"
import script from "./CarrinhoEmpresaAgrupamentoItem.vue?vue&type=script&lang=js"
export * from "./CarrinhoEmpresaAgrupamentoItem.vue?vue&type=script&lang=js"
import style0 from "./CarrinhoEmpresaAgrupamentoItem.vue?vue&type=style&index=0&id=ca54f908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports